import React from 'react';
const IconFileAdd = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13 18V15H16V13H13V10H11V13H8V15H11V18H13Z" fill="#2D2E2E"/>
<path d="M20 6.59L15.41 2H4V22H20V10H18V20H6V4H14V8H20V6.59Z" fill="#2D2E2E"/>
</svg>
);
};
export default IconFileAdd;